import React, { useState } from 'react';
import { GoSidebar, GO_TABS, GoThreeLinesIcon, IconButton, theme } from '@fiverr-private/go_shared_ui';
import { Container } from '@fiverr-private/layout_components';

interface HeaderNavigationProps {
    showCreateTab: boolean;
    showHubTab: boolean;
}

export const HeaderNavigation = ({ showCreateTab, showHubTab }: HeaderNavigationProps) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <>
            <Container
                display={{ default: 'block', sm: 'none' }}
                alignItems="center"
                position="fixed"
                height="64px"
                padding="3"
                top={0}
                left={0}
                right={0}
                zIndex="overlay"
                style={{ backgroundColor: theme.colors.grey1250 }}
            >
                <IconButton size="lg" variant="tertiary" shape="square" onClick={() => setIsSidebarOpen(true)}>
                    <GoThreeLinesIcon size={24} />
                </IconButton>
            </Container>
            <GoSidebar
                activeTab={GO_TABS.ANNOUNCEMENTS}
                showCreateTab={showCreateTab}
                showHubTab={showHubTab}
                drawerIsOpen={isSidebarOpen}
                onDrawerClose={() => setIsSidebarOpen(false)}
            />
        </>
    );
};
